

















import BaseTlTagDetail from "../../Pages/CorBase/Tag/TagDetail.vue";
import { Vue, Component, Prop } from "../../Infrastructure/CorBase/CoreBase";  

			@Component
			export default class BaseTLModalDialogDetail extends Vue { 
				@Prop({ type: String, required: true, default: "" }) id!: string;

				setSelected(id: any) {				
					Vue.nextTick(() => {	
						(this.$refs.detailModal as BaseTlTagDetail).setSelected(id);
					})					
				}

				goBack(item: any) {
					this.$emit('goBack',item);
					this.$bvModal.hide(this.id);
				}

				useSelected(selected: any): void {
			  	this.$emit('selected', selected);
					this.$bvModal.hide(this.id);
				}

				close(): void {
					this.$bvModal.hide(this.id);
				}
}

